"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeElementEvents = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Returns an events object that calls the events already defined against element. Will call both
 * the original event as defined on element as well as the event as defined under events.
 *
 * @param  {Object} events object defining React events eg: { onClick: fn(), onMouseOver: fn() }
 * @param  {ReactElement} element ReactElement
 * @return {Object}       same format as the original events object
 */
var mergeElementEvents = function mergeElementEvents(events, element) {
  return Object.keys(events).reduce(function (o, key) {
    return Object.assign({}, o, _defineProperty({}, key, function (event) {
      var _element$props$key, _element$props;

      // 1st call original method if it was defined
      // eslint-disable-next-line babel/no-unused-expressions
      (_element$props$key = (_element$props = element.props)[key]) == null ? void 0 : _element$props$key.call(_element$props, event); // 2ns call provided callback

      events[key](event);
    }));
  }, {});
}; // eslint-disable-next-line import/prefer-default-export


exports.mergeElementEvents = mergeElementEvents;